import { connect } from 'react-redux';
import HiddenByCpmType from '../components/HiddenByCpmType';
import { isCpmiCompany } from '../../../services/utils';

const mapStateToProps = ({ userAccount }) => ({
  isCpmi: isCpmiCompany(userAccount.user)
});

export default connect(mapStateToProps)(HiddenByCpmType);
